import axios from 'axios';
import { baseUrl } from '../../config';

const API = `${baseUrl}/staff-chat`;

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
  },
});

export const getContacts = async () => {
  const res = await axios.get(`${API}/contacts`, getHeaders());
  return res.data;
};

export const getConversations = async () => {
  const res = await axios.get(`${API}/conversations`, getHeaders());
  return res.data;
};

export const getOrCreateDirect = async (targetUserId) => {
  const res = await axios.post(`${API}/direct`, { target_user_id: targetUserId }, getHeaders());
  return res.data;
};

export const createGroup = async (name, memberIds) => {
  const res = await axios.post(`${API}/group`, { name, member_ids: memberIds }, getHeaders());
  return res.data;
};

export const getMessages = async (convId, page = 1) => {
  const res = await axios.get(`${API}/messages/${convId}`, { ...getHeaders(), params: { page } });
  return res.data;
};

export const sendMessage = async (conversationId, message) => {
  const res = await axios.post(`${API}/send`, { conversation_id: conversationId, message }, getHeaders());
  return res.data;
};

export const markRead = async (convId) => {
  const res = await axios.put(`${API}/read/${convId}`, {}, getHeaders());
  return res.data;
};
